// extracted by mini-css-extract-plugin
export default {"customScroll":"CustomScroll_customScroll__1yJuW","carouselContent":"CustomScroll_carouselContent__xUtfT","list":"CustomScroll_list__yXKLH"};